export const prepareNumber = (val: number, fixed: number = 0) => {
    const fixedAmount = Math.pow(10, fixed);
    return (Math.round(val * fixedAmount) / fixedAmount).toFixed(fixed);
}